// extracted by mini-css-extract-plugin
export default {"dialogs":"Dialogs_dialogs__PZTLo","empty":"Dialogs_empty__SFaxZ"};